import ajax from 'Site/js/util/ajax.fetch';
import AvatarPicker from 'Site/component/AvatarPicker.vue';
import coverImageMixin from 'Site/js/mixin/cover.image';
import dropdownDirective from 'Site/directive/dropdown';
import Editable from 'Site/component/Editable.vue';
import Invite from 'Site/component/SelectFriends.vue';
import Message from 'Messaging/component/Message.vue';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';


export default function () {
    new Vue({ /* eslint no-new:0 */
        el: '#group-header',
        name: 'groupHeader',
        store,
        computed: {
            ...mapState({
                id: state => state.config.data.id,
                groupAjaxParams: state => ({ url: 'group', id: state.config.data.id }),
                notifications: state => state.config.data.notifications,
                t: state => state.t
            })
        },
        components: {
            AvatarPicker,
            Editable,
            Invite,
            Message
        },
        directives: {
            dropdown: dropdownDirective
        },
        data() {
            return {
                groupPrivacyOptions: [
                    { value: '0', text: this.$store.state.t.view ? this.$store.state.t.view.public : '' },
                    { value: '2', text: this.$store.state.t.view ? this.$store.state.t.view.private : '' },
                    { value: '1', text: this.$store.state.t.view ? this.$store.state.t.view.invite_only : '' }
                ],
                showLogoModal: false,
                showInviteFriends: false,
                showMessageMembers: false
            };
        },
        methods: {
            ...mapActions(['notify']),
            changeCoverImage(coverImage) {
                this.showCoverImageModal = false;
                this.coverImage = coverImage.url;
                if (coverImage.upload) {
                    this.notify({ msg: this.t.cover_image_awaiting_approval });
                    return;
                }
                let params = { id: this.id, cover: coverImage.id };
                if (coverImage.site) {
                    params = { id: this.id, theme: coverImage.name };
                }
                ajax.update('group', params).then(() => {
                    this.notify({ msg: this.t.cover_image_updated });
                });
            },
            changeLogo() {
                this.showLogoModal = true;
            },
            changeLogoImage(logo) {
                this.showLogoModal = false;
                document.querySelector('.coverimage-logo').style['background-image'] = `url(${logo.media['large-thumbnail'].url})`;
                ajax.update('group', { id: this.id, logo: logo.id }).then(() => {
                    this.notify({ msg: this.t.header.logo_updated });
                });
            },
            inviteCallback(users) {
                ajax.create('groupInvite', { username: users, group: this.id }).then((response) => {
                    this.notify({ msg: response.message });
                }).catch(({ response }) => {
                    response.then((error) => {
                        this.notify({ type: 'error', msg: error.message });
                    });
                });
            },
            messageCallback({ subject, body }) {
                ajax.create('groupMessage', {
                    group: this.id,
                    subject,
                    body
                }).then((response) => {
                    this.notify({ msg: response.message });
                });
            },
            toggleNotifications() {
                if (this.notifications.enabled) {
                    this.notifications.enabled = false;
                    this.persistNotificationSetting(0);
                } else {
                    this.notifications.enabled = true;
                    this.persistNotificationSetting(1);
                }
            },
            persistNotificationSetting(notifications) {
                ajax.update('acl', { id: this.notifications.id, notifications }).then((response) => {
                    this.notify({ msg: response.message });
                });
            },
            showInviteModal() {
                this.showInviteFriends = true;
            },
            showMessageModal() {
                this.showMessageMembers = true;
            }
        },
        mixins: [coverImageMixin]
    });
}
